import { definitions } from "../../types/supabase";
import { ResourceConsumerWithResource } from "../pages/learningLibrary/learningLibraryTypes";
import { getEnvVarOrRaise } from "./envVars";

export const logoCC =
  "https://cc-prd-retool.s3.amazonaws.com/piaf/resources/f95cd36d-aa33-4f27-b4a5-754cda787cd3/piaf-logo-light-small.png";
export const logoPiaf =
  "https://cc-prd-retool.s3.amazonaws.com/piaf/resources/f95cd36d-aa33-4f27-b4a5-754cda787cd3/piaf-logo-light-small.png";
export const logoNMA =
  "https://cc-prd-retool.s3.amazonaws.com/nma/resources/09e3f4c4-c001-4118-a96b-151ae62ed118/NMAlogo-01.png";
export const logoTP =
  "https://cc-prd-retool.s3.amazonaws.com/tp/resources/f02205f3-94f8-40c8-9b9e-5664880e402a/the_prepared_logo.png";
export const logoPS =
  "https://cc-prd-retool.s3.amazonaws.com/ps/resources/5a8a9a55-5aa6-41fd-9031-a87327d90dc6/logo-og.png";
export const logoDA =
  "https://cc-prd-retool.s3.amazonaws.com/da/resources/5b5331e0-3bbb-447c-a032-9f08daf79d44/da-fullcolor.png";
export const logoBTB =
  "https://www.hobbyresources.com/btb/resources/5154475b-f518-4b75-8714-28f23f585dca/1.01.02-1000x1000-Combined Curiosity-JPC-249606.png";
export const logoUKE =
  "https://prd.hobbyresources.com/uke/resources/f1cce55c-7bd3-475c-94d2-9536a718d906/1.01.02-1000x1000-Combined Curiosity-JPC-250807.png";
// Update these with the correct logos
export const logoFFA =
  "https://www.hobbyresources.com/ffa/resources/8cacf6bf-e93d-42ee-ad0d-60605b9e6d46/favicon-32x32.png";
export const logoPB =
  "https://www.hobbyresources.com/pb/resources/8cacf6bf-e93d-42ee-ad0d-60605b9e6d46/favicon-32x32.png";
export const logoBBF =
  "https://www.hobbyresources.com/bbf/resources/8cacf6bf-e93d-42ee-ad0d-60605b9e6d46/favicon-32x32.png";
export const logoUFK =
  "https://www.hobbyresources.com/ufk/resources/8cacf6bf-e93d-42ee-ad0d-60605b9e6d46/favicon-32x32.png";
export const logoGT =
  "https://www.hobbyresources.com/gt/resources/d7cf81a2-5d99-4b16-be0b-f47324347149/Graston Technique Logo small.png";

export const faviconCC =
  "https://cc-prd-retool.s3.amazonaws.com/piaf/resources/4797bcbe-0577-4af2-9347-f60cf2fc17d1/piaf-favicon-V2.png";
export const faviconPiaf =
  "https://cc-prd-retool.s3.amazonaws.com/piaf/resources/4797bcbe-0577-4af2-9347-f60cf2fc17d1/piaf-favicon-V2.png";
export const faviconNMA =
  "https://cc-prd-retool.s3.amazonaws.com/nma/resources/80f17621-76eb-402a-9c48-148f634521e6/NMA-favicon.png";
export const faviconTP =
  "https://cc-prd-retool.s3.amazonaws.com/tp/resources/584d171a-2a30-45cf-a10a-10be795d2983/the-prepared-logo.png";
export const faviconPS =
  "https://cc-prd-retool.s3.amazonaws.com/ps/resources/29a05c8e-5fa9-4631-b4be-d7873634056b/pie-favicon.png";
export const faviconDA =
  "https://cc-prd-retool.s3.amazonaws.com/da/resources/8cacf6bf-e93d-42ee-ad0d-60605b9e6d46/favicon-32x32.png";
export const faviconBTB =
  "https://prd.hobbyresources.com/btb/resources/752d3d85-109d-435f-b27f-1bc2f2944f2f/favicon.ico";
export const faviconUKE =
  "https://prd.hobbyresources.com/uke/resources/542d4393-665b-4161-ab67-b6f8a6208034/favicon-32x32.png";
// Update these with the correct favicons
export const faviconFFA =
  "https://cc-prd-retool.s3.amazonaws.com/ffa/resources/8cacf6bf-e93d-42ee-ad0d-60605b9e6d46/favicon-32x32.png";
export const faviconPB =
  "https://cc-prd-retool.s3.amazonaws.com/pb/resources/8cacf6bf-e93d-42ee-ad0d-60605b9e6d46/favicon-32x32.png";
export const faviconBBF =
  "https://cc-prd-retool.s3.amazonaws.com/bbf/resources/8cacf6bf-e93d-42ee-ad0d-60605b9e6d46/favicon-32x32.png";
export const faviconUFK =
  "https://cc-prd-retool.s3.amazonaws.com/ufk/resources/8cacf6bf-e93d-42ee-ad0d-60605b9e6d46/favicon-32x32.png";
export const faviconGT = "https://cc-prd-retool.s3.amazonaws.com/gt/resources/";

const environment = getEnvVarOrRaise("ENV");

// brands that serve the xms-api through their own domain
const ccApiHostForBrand = (brandAbbreviation?: string) => {
  switch (brandAbbreviation) {
    case "nma":
      return "https://cc-api.nancymedina.com";
    case "piaf":
      return "https://cc-api.pianoinaflash.com";
    case "tp":
      return "https://cc-api.theprepared.com";
    case "ps":
      return "https://cc-api.thepiesavvy.com";
    case "da":
      return "https://cc-api.drumambition.com";
    case "btb":
      return "https://cc-api.breakthroughbanjo.com";
    case "uke":
      return "https://cc-api.ukuleleblast.com";
    case "ffa":
      return "https://cc-api.fiddleforall.com";
    case "pb":
      return "https://cc-api.pianoblast.com";
    case "bbf":
      return "https://cc-api.betterbrain.fitness";
    case "ufk":
      return "https://cc-api.ukuleleforkids.com";
    case "gt":
      return "https://cc-api.grastontechnique.com";
    default:
      return undefined;
  }
};

class BrandConfig {
  brandId: string | undefined;
  brandName: string | undefined;
  brandDescription: string | undefined;
  brandConfig: any;
  brandAbbreviation: string | undefined;
  brandResources: Array<ResourceConsumerWithResource>;

  getBrandAbbreviationForCurrentURL = () => {
    const { host } = location;

    if (host.startsWith("mop") || host.includes("masteroilpainting")) {
      return "mop";
    } else if (host.startsWith("nma") || host.includes("nancymedina")) {
      return "nma";
    } else if (host.startsWith("piaf") || host.includes("pianoinaflash")) {
      return "piaf";
    } else if (host.startsWith("tp") || host.includes("theprepared")) {
      return "tp";
    } else if (host.startsWith("ps") || host.includes("thepiesavvy")) {
      return "ps";
    } else if (host.startsWith("da") || host.includes("drumambition")) {
      return "da";
    } else if (host.startsWith("btb") || host.includes("breakthroughbanjo")) {
      return "btb";
    } else if (host.startsWith("uke") || host.includes("ukuleleblast")) {
      return "uke";
    } else if (host.startsWith("ffa") || host.includes("fiddleforall")) {
      return "ffa";
    } else if (host.startsWith("pb") || host.includes("pianoblast")) {
      return "pb";
    } else if (host.startsWith("bbf") || host.includes("betterbrain")) {
      return "bbf";
    } else if (host.startsWith("ufk") || host.includes("ukuleleforkids")) {
      return "ufk";
    } else if (host.startsWith("gt") || host.includes("grastontechnique")) {
      return "gt";
    } else if (host.startsWith("test") || host.includes("test")) {
      return "test";
    } else {
      console.warn("Unknown brand!");
    }
  };

  constructor() {
    this.brandAbbreviation = this.getBrandAbbreviationForCurrentURL();
    this.brandResources = [];
  }

  // for App.js
  getFetchBrandOptions() {
    return [
      "nma",
      "piaf",
      "tp",
      "test",
      "ps",
      "da",
      "btb",
      "uke",
      "ffa",
      "pb",
      "bbf",
      "ufk",
      "gt",
    ];
  }

  // for loginForm + dashboard
  getBrandList() {
    return [
      {
        logo: logoPiaf,
        favicon: faviconPiaf,
        label: "piaf",
        height: "75",
        styling: "py-6",
      },
      { logo: logoTP, favicon: faviconTP, label: "tp" },
      { logo: logoNMA, favicon: faviconNMA, label: "nma" },
      { logo: logoPS, favicon: faviconPS, label: "ps" },
      { logo: logoDA, favicon: faviconDA, label: "da" },
      { logo: logoBTB, favicon: faviconBTB, label: "btb" },
      { logo: logoUKE, favicon: faviconUKE, label: "uke" },
      { logo: logoFFA, favicon: faviconFFA, label: "ffa" },
      { logo: logoPB, favicon: faviconPB, label: "pb" },
      { logo: logoBBF, favicon: faviconBBF, label: "bbf" },
      { logo: logoUFK, favicon: faviconUFK, label: "ufk" },
      { logo: logoGT, favicon: faviconGT, label: "gt" },
    ];
  }

  setBrandConfig(
    brandId: string,
    brandName: string,
    brandDescription: string,
    brandAbbreviation: string,
    brandConfig: any,
    brandResources: Array<ResourceConsumerWithResource>
  ) {
    this.brandId = brandId;
    this.brandName = brandName;
    this.brandDescription = brandDescription;
    this.brandConfig = brandConfig || {};
    this.brandAbbreviation = brandAbbreviation;
    this.brandResources = brandResources;
  }

  getCustomColors() {
    return {
      primary: this.brandConfig?.primary_rgb_color || "0 0 0",
      secondary: this.brandConfig?.secondary_rgb_color || "0 0 0",
      tertiary: this.brandConfig?.tertiary_rgb_color || "0 0 0",
      quaternary: this.brandConfig?.quaternary_rgb_color || "0 0 0",
    };
  }

  zendeskKey() {
    return this.brandConfig?.zendesk_key || "";
  }

  navbarImage() {
    return (
      this.getBrandList().find((b) => b.label == this.brandAbbreviation)
        ?.logo || logoCC
    );
  }

  favicon() {
    return (
      this.getBrandList().find((b) => b.label == this.brandAbbreviation)
        ?.favicon || logoCC
    );
  }

  brandType() {
    switch (this.brandAbbreviation) {
      case "nma":
        return "Painting";
      case "piaf":
        return "Piano";
      case "tp":
        return "Teaching";
      case "ps":
        return "Baking";
      case "da":
        return "Drumming";
      case "btb":
        // Validate with support/marketing
        return "Strumming";
      case "uke":
        return "Ukulele";
      case "ffa":
        return "Fiddle";
      case "pb":
        return "Piano";
      case "bbf":
        return "Brain Fitness";
      case "ufk":
        return "Ukulele";
      case "gt":
        return "IASTM Training";
      default:
        return "";
    }
  }

  getWelcomeVideoForUserProfile(profile: definitions["profiles"]) {
    if (profile.original_brand_identifier) {
      const transitionWelcomeVideo = this.brandResources.find((resource) => {
        return (
          resource.display_type == "welcome_video_transition_from_old_system"
        );
      });

      if (transitionWelcomeVideo) {
        return transitionWelcomeVideo;
      }
    }

    return this.brandResources.find((resource) => {
      return resource.display_type == "welcome_video";
    });
  }

  brandFullName() {
    return this.brandName;
  }

  brandHomepageLink(label?: string) {
    const brand = label || this.brandAbbreviation;
    switch (brand) {
      case "nma":
        return "https://www.nancymedina.com/joyful";
      case "piaf":
        return "https://www.pianoinaflash.com/";
      case "tp":
        return "https://www.theprepared.com/";
      case "ps":
        return "https://www.thepiesavvy.com/";
      case "da":
        return "https://www.drumambition.com/";
      case "btb":
        return "https://www.breakthroughbanjo.com/";
      case "uke":
        return "https://www.ukuleleblast.com/";
      case "ffa":
        return "https://www.fiddleforall.com/";
      case "pb":
        return "https://www.pianoblast.com/";
      case "bbf":
        return "https://www.betterbrain.fitness/";
      case "ufk":
        return "https://www.ukuleleforkids.com/";
      case "gt":
        return "https://www.grastontechnique.com/";
      default:
        return "https://www.pianoinaflash.com/";
    }
  }

  brandServerUrl() {
    if (environment === "local") {
      return `http://localhost:3001/marketing/${this.brandAbbreviation}`;
    }

    return (
      ccApiHostForBrand(this.brandAbbreviation) ||
      "https://prd-xms-api.combinedcuriosity.com"
    );
  }

  // Base URL for xms-api calls. In prd, route through the brand's own
  // cc-api.<brand-domain> host instead of *.combinedcuriosity.io, which some
  // learners' networks cannot complete a TLS handshake with. Derived from the
  // hostname (not fetched brand config) so it is correct at import time.
  apiUrl() {
    const ccApiHost =
      environment === "prd"
        ? ccApiHostForBrand(this.getBrandAbbreviationForCurrentURL())
        : undefined;

    return ccApiHost ? `${ccApiHost}/api` : getEnvVarOrRaise("API_URL");
  }

  introCompletionOfferLink() {
    return this.brandConfig?.intro_completion_offer_link || "";
  }
}

const brandConfig = new BrandConfig();

export { brandConfig };
